//import React from "react";
import logo1 from "../assets/logo1.png";

export default function Header() {
  return (
    <header style={headerStyle}>
      {/* Logo + Name */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <img src={logo1} alt="Logo" style={{ height: "50px" }} />
        <div style={titleStyle}>
          Digital<br />
          <span style={{ color: "#180404e9", fontWeight: "bold" }}>
            Innovation Delivered
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav style={navStyle}>
        <a
          href="https://e4softwares.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Home
        </a>
        
      </nav>
    </header>
  );
}

// ================= STYLES =================
const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "15px 50px",
  background: "linear-gradient(135deg, #ffffffff, #ffffffff)", // vibrant gradient
  boxShadow: "0 8px 20px rgba(0,0,0,0.2)", // stronger shadow
  borderRadius: "0 0 25px 25px", // smooth rounded bottom
  backdropFilter: "blur(8px)", // subtle glass effect
  position: "sticky",
  top: 0,
  zIndex: 1000,
};

const titleStyle = {
  fontSize: "22px",
  lineHeight: "26px",
  color: "#000000ff",
  textShadow: "1px 1px 2px rgba(0,0,0,0.3)",
};

const navStyle = {
  display: "flex",
  gap: "25px",
};

const linkStyle = {
  color: "#ee3434ff",
  textDecoration: "none",
  fontWeight: "bold",
  padding: "8px 16px",
  borderRadius: "10px",
  transition: "all 0.3s ease",
  background: "rgba(255,255,255,0.1)", // semi-transparent button look
};

linkStyle["hover"] = {
  background: "rgba(255,255,255,0.25)",
};
